import { Chart } from "primereact/chart";
import React from "react";

const TlPieChart = React.memo(({ totalTimeLogsCounts }: any) => {
  const pending = parseInt(totalTimeLogsCounts.totalPendingTimelogs || "0");
  const submitted = parseInt(totalTimeLogsCounts.totalSubmittedTimelogs || "0");
  const submittedToManager = parseInt(
    totalTimeLogsCounts.totalManagerSubmittedTimeLogs || "0"
  );
  const approvedByManager = parseInt(
    totalTimeLogsCounts.totalApprovedByManagerTimeLogs || "0"
  );
  const rejectedByManager = parseInt(
    totalTimeLogsCounts.totalRejectedByManagerTimeLogs || "0"
  );
  const rejected = parseInt(totalTimeLogsCounts.totalRejectedTimeLogs || "0");
  const approved = parseInt(totalTimeLogsCounts.totalApprovedTimelogs || "0");
  const missing = parseInt(totalTimeLogsCounts.totalMissingTimeLogs || "0");

  const total =
    pending +
    submitted +
    approved +
    missing +
    submittedToManager +
    approvedByManager +
    rejectedByManager +
    rejected;

  const data = {
    labels: [
      "Pending",
      "Submitted",
      "Approved",
      "Missing",
      "Submitted To Manager",
      "Approved by Manager",
      "Rejected by Manager",
      "Rejected",
    ],
    datasets: [
      {
        data: [
          pending,
          submitted,
          approved,
          missing,
          submittedToManager,
          approvedByManager,
          rejectedByManager,
          rejected,
        ],
        backgroundColor: [
          "#eab308",
          "#007aff",
          "#17B26A",
          "#E99494",
          "#0255b0",
          "#a6448e",
          "#ff6b6b",
          "#dc2626",
        ],
        hoverBackgroundColor: [
          "#f5c531",
          "#0970e0",
          "#149157",
          "#c98383",
          "#052c57",
          "#9e1c7f",
          "#ff5252",
          "#b91c1c",
        ],
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const val = tooltipItem.raw || 0;
            const percent = ((val / total) * 100).toFixed(1);
            return `Count: ${val} (${percent}%)`;
          },
        },
      },
      legend: {
        display: true,
        position: "right" as const,
        align: "center" as const,
        labels: {
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map((label: any, i: number) => {
                const value = data.datasets[0].data[i];
                const percentage = ((value / total) * 100).toFixed(1);
                return {
                  text: `${label}: ${value} (${percentage}%)`,
                  fillStyle: data.datasets[0].backgroundColor[i],
                  hidden:
                    isNaN(data.datasets[0].data[i]) ||
                    chart.getDatasetMeta(0).data[i]?.hidden,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-w-full tw-h-64 md:tw-h-72 lg:tw-h-80">
        <Chart type="pie" data={data} options={options} />
      </div>
      <div className="tw-mt-6 tw-text-center tw-font-medium tw-text-gray-700">
        Total Logs: {total}
      </div>
    </div>
  );
});

export default TlPieChart;
